import postImageView from './postImageComponent.html';
import VideoPlayer from 'components/sharpr/videoPlayer/VideoPlayer';
import './postImageComponent.css';
import _ from 'lodash';

export function postImageComponent() {
	return {
		bindings: {
			post: '=',
			geometry: '<',
			linkTo: '<?',
			cursorOverride: '<?',
			allowEnlarge: '<?',
			showMissing: '<?',
			isMinimal: '<?',
			iconType: '<',
			fileCount: '<',
			useAsMissing: '<?',
		},
		controllerAs: 'vm',
		controller: postImageComponentCtrl,
		template: postImageView,
	};
}

class postImageComponentCtrl {
	constructor($scope, ImageSizer, Theme, Api, $window, modal, EventTracker) {
		'ngInject';
		this.$scope = $scope;
		this.Theme = Theme;
		this.Api = Api;
		this.$window = $window;
		this.ImageSizer = ImageSizer;
		this.modal = modal;
		this.EventTracker = EventTracker;
	}

	$onInit() {
		this.$scope.$watchGroup(
			[
				'vm.geometry',
				'vm.post.image.url',
				'vm.post.image.width',
				'vm.post.image.height',
				'vm.post.attachments',
				'vm.post.videos',
			],
			(newVal, oldVal) => {
				if (newVal != oldVal) {
					this.setup();
				}
			}
		);
		this.postImageLinkStyle = {};
		this.setup();
	}

	setup() {
		this.missingImageUrl = this.Theme.img('missing.png');
		if (this.post.image && this.post.image.url == this.missingImageUrl) {
			this.isMissing = true;
		}
		if (this.post.image && !this.isPlaceHolder()) {
			this.setupImage();
		} else if (this.isVideo()) {
			this.setupVideo();
		} else if (this.post.attachment_icons) {
			this.setupAttachments();
		} else {
			this.src = null;
			this.isMissing = true;
		}
		if (this.needsMissing()) {
			this.setupMissing();
		}
		if (this.cursorOverride) {
			this.cursor = this.cursorOverride;
		} else {
			this.cursor = this.linkTo ? 'pointer' : 'default';
		}
		// defaults to using <sh-image> to display the image
		this.useAsMissing = this.useAsMissing ? this.useAsMissing : 'img';
		this.setupPostImageLinkStyle();
	}

	needsMissing() {
		return this.isMissing && this.showMissing;
	}

	setupImage() {
		this.displaySize = this.ImageSizer.getSize(this.post.image, this.geometry);
		this.width = this.displaySize[0];
		this.height = this.displaySize[1];
		this.isEnlargeable = this.post.image.width > this.displaySize[0] || this.post.image.height > this.displaySize[1];
		if (this.allowEnlarge !== undefined && !this.allowEnlarge) {
			this.isEnlargeable = false;
		}
		this.suffix = this.geometry ? '.' + this.geometry : '';
		this.src = this.post.image.url;
		this.href = this.post.source_link ? this.post.source_link : '';
		if (this.suffix) {
			this.removePinFromSrc();
			// allow animated gifs
			if (this.src && this.src.match(/\.gif$/i)) {
				this.suffix += '.gif?useEngine=convert';
			}
			// ensure pngs are always kept as pngs
			else if (this.src && this.src.match(/\.png$/i)) {
				this.suffix += '.png';
			} else {
				this.suffix += '.jpg';
			}
		}
		if (this.post.image.url.match(/img\/video-background\-/)) {
			this.suffix = '';
			this.removePinFromSrc();
		}
		if (this.post.image.isFilePreview) {
			this.suffix = '';
		}
	}

	setupVideo() {
		// playable video but no post image;
		// default to a video placeholder image
		let spec = this.ImageSizer.parse(this.geometry);
		let bgImgPrefix = `${window.BASE_URL}/assets/img/video-background-`;
		if (spec.boundingWidth > 800) {
			this.post.image = { width: 940, height: 360, url: bgImgPrefix + '940.jpg' };
		} else if (spec.boundingWidth > 260) {
			this.post.image = { width: 800, height: 306, url: bgImgPrefix + '800.jpg' };
		} else {
			this.post.image = { width: 260, height: 195, url: bgImgPrefix + '260.jpg' };
		}
		this.isEnlargeable = false;
		this.suffix = '';
		this.displaySize = this.ImageSizer.getSize(this.post.image, this.geometry);
		this.width = this.displaySize[0];
		this.height = this.displaySize[1];
		this.src = this.post.image.url;
	}

	/**
	 * Use the first attachment thumbnail, if any. Otherwise, use the file type's default icon.
	 */
	setupAttachments() {
		const spec = this.ImageSizer.parse(this.geometry);
		const size = spec > 260 ? 'primary' : 'secondary';

		// use the first attachment thumbnail if we have any
		if (this.post.attachment_thumbnails && this.post.attachment_thumbnails.length) {
			this.post.image = this.post.attachment_thumbnails[0];
			this.setupImage();
			return;
		}
		// otherwise, use the file type's default icon
		this.post.image = {
			width: spec.boundingWidth,
			height: Math.round(spec.boundingWidth / 1.3333333), // icons are 4:3 ratio
			url: `${window.BASE_URL}/assets/img/filetypes/${size}/${this.post.attachment_icons[0]}.png`,
		};
		this.width = this.post.image.width;
		this.height = this.post.image.height;
		this.src = this.post.image.url;
		this.suffix = '';
	}

	setupMissing() {
		this.post.image = {
			url: this.missingImageUrl,
			width: 1000,
			height: 750,
		};
		this.setupImage();
		this.suffix = '';
		// console.log('postImageComponent setupMissing!', this);
	}

	onError() {
		this.src = null;
		this.isMissing = true;
		// imgComponent runs digest at this point
	}

	isVideo() {
		return !!VideoPlayer.getPlayableUrl(this.post);
	}

	getScreenArea() {
		// innerWidth and innerHeight should work on IE 11+
		return [this.$window.innerWidth - 60, this.$window.innerHeight - 100];
	}

	markAsViewed() {
		const source = document.title.replace(' :: Sharpr', '');
		this.EventTracker.save('post_view', {
			post_id: this.post.id,
			source,
		});
	}

	handleLinkTo($event) {
		if (this.isMinimal) {
			$event.preventDefault();
			return null;
		}

		if (this.isVideo() && !!this.linkTo) {
			$event.preventDefault();
			// mark viewed after 5 seconds
			const markViewed = setTimeout(() => this.markAsViewed(), 5000);
			const noteClosed = () => clearTimeout(markViewed);
			// open modal
			this.modal
				.video(this.post, {
					// TODO: get attachment name if video is an attachment (maybe update ModalService#video)
					heading: this.post.headline,
					height: 'full',
					width: 'full',
				})
				.then(noteClosed, noteClosed);
		} else if (this.linkTo == 'source') {
			if (this.post.source_link) {
				// let <a> do its thing and open source article in new tab
				if (this.post.id) {
					this.markAsViewed();
					this.EventTracker.save('click_source', {
						post_id: this.post.id,
						url: this.post.source_link,
					});
				}
			} else {
				// post has no source to go to; just stay here
				$event.preventDefault();
				this.markAsViewed();
				this.fullscreen();
			}
		} else if (this.linkTo == 'enlarged') {
			$event.preventDefault();
			this.enlarge($event);
		} else if (this.linkTo == 'detail') {
			$event.preventDefault();
			this.markAsViewed();
			this.fullscreen();
		} else if (this.linkTo == 'fullscreen') {
			$event.preventDefault();
			this.fullscreen();
		} else if (this.linkTo == 'edit') {
			$event.preventDefault();
			this.edit();
		} else {
			// clicking the image should do nothing
			$event.preventDefault();
		}
	}

	hasRoomForEnlargeModal() {
		let size = this.getScreenArea();
		return (
			this.post.image.width < size[0] &&
			// 68 is modal top bar height + iframe chrome
			this.post.image.height + 68 < size[1]
		);
	}

	enlarge($event) {
		let viewer_type;
		if (this.openWithNativeViewer()) {
			viewer_type = 'native';
		}
		if (this.hasRoomForEnlargeModal()) {
			// enlargement modal will fit in window
			$event.preventDefault();
			this.modal.iframe(this.post.image.url, {
				heading: this.post.headline,
				width: this.post.image.width,
				// 68 is modal top bar height + iframe chrome
				height: this.post.image.height + 68,
			});
			viewer_type = 'modal';
		} else {
			// let <a> do its thing and open image in new tab
			viewer_type = 'new tab';
		}
		this.EventTracker.save('enlarge_image', {
			post_id: this.post.id,
			viewer_type,
			img_width: this.post.image.width,
			img_height: this.post.image.height,
		});
	}

	fullscreen() {
		if (this.openWithNativeViewer()) {
			return;
		}
		this.modal.state('hub.PostDetail', {
			params: { id: this.post.id, isArchived: this.post.is_archived },
			heading: this.post.headline,
			width: 'full',
			height: 'full',
		});
	}

	edit() {
		this.modal
			.state('hub.loggedin.PostEdit', {
				params: { id: this.post.id },
				heading: 'Edit Post',
				width: 'full',
				height: 'full',
			})
			.then(() => {
				this.Api.get(`/posts/${this.post.id}`).then(updatedPost => {
					// use _.extend so that parent scopes get changed post
					_.extend(this.post, updatedPost);
				});
			});
	}

	isPlaceHolder() {
		return this.post.image.url.match(/filetypes/);
	}

	removePin(url) {
		return url.replace(/\.pin-[0-9]+\.jpg/, '');
	}

	removePinFromSrc() {
		this.src = this.removePin(this.src);
	}

	openWithNativeViewer() {
		if (window.isMobile && cordova) {
			let open = cordova.plugins.disusered.open;
			open(
				this.removePin(this.post.image.url),
				() => {},
				() => console.log('cordova-open failed')
			);
			return true;
		}
	}

	setupPostImageLinkStyle() {
		const defaultBg = this.isMinimal ? '#FFFFFF' : 'none';
		const missingBg = 'white url(' + this.missingImageUrl + ') no-repeat 50% 50% / contain';
		const background = this.needsMissing() ? missingBg : defaultBg;
		const style = {
			cursor: this.cursor,
			background,
		};

		// we need this to have fixed dimensions since it won't have an inner image to give it dimensions anymore
		if (this.needsMissing() && this.useAsMissing == 'background-image') {
			style.width = this.width + 'px';
			style.height = this.height + 'px';
		}

		this.postImageLinkStyle = style;
	}
}
